import styled from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export interface ScSkeletonProps {
  width?: number;
  padding?: number;
  radius?: number;
}

export const ScStaticModalSkeleton = styled.div<ScSkeletonProps>`
  max-width: ${({ width }) => (width ? `${width}px` : '480px')};
  border-radius: ${({ radius }) => (radius ? `${radius}px` : '16px')};
  background: ${({ theme }) => theme.whiteColor};
  margin: 32px auto;
  padding: ${({ padding }) => (padding ? `${padding}px` : '16px')};
  position: relative;
  &:before {
    content: '';
    display: block;
    position: absolute;
    inset: ${({ padding }) => (padding ? `${padding}px` : '16px')};
    top: 180px;
    border-radius: 24px;
    width: ${({ padding }) =>
      padding ? `calc(100% - ${padding * 2})` : 'calc(100% - 32px)'};
    background: ${({ theme }) => hexToRGB(theme.blackColor, 0.05)};
  }
`;

export const ScStaticModalSkeletonMobile = styled.div`
  height: 100vh;
  padding: 16px;
  position: relative;
  background: none;
  height: 100vh;
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 32px;
    top: 180px;
    right: 16px;
    left: 16px;
    bottom: 16px;
    border-radius: 24px;
    width: calc(100% - 32px);
    background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.05)};
  }
`;
